import { createRouter, createWebHashHistory } from 'vue-router'
import { 
  TeamOutlined,
  ApartmentOutlined,
  SolutionOutlined,
  HistoryOutlined,
  ReadOutlined
} from '@ant-design/icons-vue/lib/icons';

// 导入流向数据路由模块
import flowDataRoutes from './modules/flow-data'

// 导入统一客户管理路由模块
import unifiedCustomerRoutes from './modules/unified-customer'

// 导入药品代理商系统路由模块
import agentRoutes from './modules/agent'

// 导入主数据管理中心路由模块(已废弃,保留导入以避免编译错误)
import masterDataCenterRoutes from './modules/master-data-center'

// 导入系统管理路由模块
import systemRoutes from './modules/system'

// 导入异常管理中心路由模块
import anomalyCenterRoutes from './modules/anomaly-center'

// 导入数据分析路由模块
import dataAnalysisRoutes from './modules/data-analysis'

// 导入销售代表主数据路由模块
import representativeRoutes from './modules/representative'

// 导入审计支撑中心路由模块（V1 新增）
import auditSupportRoutes from './modules/audit-support'

// 导入经营大脑（三核一舱）门户路由模块
import operationBrainRoutes from './modules/operation-brain'

// 路由懒加载
const Login = () => import('../views/login/index.vue')
const Dashboard = () => import('../views/dashboard/index.vue')
const AccessDenied = () => import('../views/access-denied.vue')

// 数据处理中心
const DataProcess = () => import('../views/data-process/index.vue')
const DataImport = () => import('../views/data-process/import/index.vue')
// 修改为独立的三级菜单页面
const FileImportPage = () => import('../views/data-process/import/file-import.vue')
const FileImportNew = () => import('../views/data-process/import/FileImportNew.vue')
const DdiImportPage = () => import('../views/data-process/import/ddi-import.vue')
const WebImportPage = () => import('../views/data-process/import/web-import.vue')
const ManualImportPage = () => import('../views/data-process/import/manual-import.vue')
// V2.0: 数据清洗测试页面 (已废弃,仅供开发调试)
const DataCleaningTest = () => import('../views/data-process/import/DataCleaningTest.vue')
// 数据确认页面 (正式生产页面)
const DataCleaningPage = () => import('../views/data-process/import/DataCleaningPage.vue')
// 数据核验结果页面 (Sprint 3 新增)
const DataVerificationPage = () => import('../views/data-process/import/DataVerificationPage.vue')
// const Standardization = () => import('../views/data-process/standardization/index.vue') // 旧版标准化页面
const Standardization = () => import('../views/data-process/standardization/StandardizationOrchestrator.vue') // 优化版标准化编排器
// 将已实现的组件取消注释
const Verification = () => import('../views/data-process/verification/index.vue')
const VerificationWorkbench = () => import('../views/data-process/verification/VerificationWorkbench.vue') // 新核验工作台
const VerificationConfig = () => import('../views/data-process/verification/VerificationConfig.vue') // 核验配置管理
const Accounting = () => import('../views/data-process/accounting/index.vue')
// const Reporting = () => import('../views/data-process/reporting/index.vue') // 未找到该文件，保持注释
// 将懒加载修改为立即加载
// const ProcessHistory = () => import('../views/data-process/history/index.vue')
const ProcessHistory = () => import('../views/data-process/history/index.vue')
// 新增DDI管理页面
const DdiManagement = () => import('../views/data-process/ddi-management/index.vue')
// 新增网站配置管理页面
const WebsiteConfig = () => import('../views/data-process/website-config/index.vue')
// 新增数据修复工具和多级审批配置页面
const DataFixTool = () => import('../views/data-process/verification/components/DataFixTool.vue')
const ApprovalFlowConfig = () => import('../views/data-process/verification/components/ApprovalFlowConfig.vue')

// 规则管理中心
const RuleManagement = () => import('../views/rule-management/index.vue')
const RuleList = () => import('../views/rule-management/RuleList.vue')
const RuleEditor = () => import('../views/rule-management/RuleEditor.vue')
const RuleTester = () => import('../views/rule-management/RuleTester.vue')
const RuleVersions = () => import('../views/rule-management/RuleVersions.vue')

// 模板管理中心 (将被移除)
// const TemplateManagement = () => import('../views/template-management/index.vue')
// const TemplateEditor = () => import('../views/template-management/template-editor.vue')
// const TemplateVersions = () => import('../views/template-management/template-versions.vue')

// 主数据管理
const MasterData = () => import('../views/master-data/index.vue')

// 主数据管理子模块
const ProductMasterData = () => import('../views/master-data/product/index.vue')
const ProductDetail = () => import('../views/master-data/product/detail.vue')
const ProductEdit = () => import('../views/master-data/product/edit.vue')
const SpecMasterData = () => import('../views/master-data/spec/index.vue')
const SpecDetail = () => import('../views/master-data/spec/detail.vue')
const SpecEdit = () => import('../views/master-data/spec/edit.vue')
const OrganizationMasterData = () => import('../views/master-data/organization/index.vue')
const PositionManagement = () => import('../views/master-data/organization/position-management.vue')
const EmployeeAssociation = () => import('../views/master-data/organization/employee-association.vue')
const RegionDetail = () => import('../views/master-data/region/detail.vue')
const RegionEdit = () => import('../views/master-data/region/edit.vue')
const RegionAdd = () => import('../views/master-data/region/edit.vue')
const RegionManagement = () => import('../views/master-data/region/management.vue')
const RegionSelectorDemo = () => import('../views/master-data/region/region-selector-demo.vue')
const PriceMasterData = () => import('../views/master-data/price/index.vue')
const PriceDetail = () => import('../views/master-data/price/detail.vue')
const PriceEdit = () => import('../views/master-data/price/edit.vue')
// 价格管理新增页面
const PriceTypeManager = () => import('../views/master-data/price/type-manager.vue')
const PriceSpecRelation = () => import('../views/master-data/price/spec-relation.vue')
const PriceValidator = () => import('../views/master-data/price/price-validator.vue')

// 统一客户管理模块
const CustomerManagement = () => import('../views/master-data/customer/index.vue')
// 注释掉已删除的文件导入
// const CustomerDetail = () => import('../views/master-data/customer/detail.vue')
// const CustomerEdit = () => import('../views/master-data/customer/edit.vue')
// const CustomerCreate = () => import('../views/master-data/customer/edit.vue')
const UnifiedCustomerView = () => import('../views/master-data/customer/unified-view.vue')
const CustomerAdd = () => import('../views/master-data/customer/add.vue')
const UnifiedFlowDataAnalysis = () => import('../components/customer/UnifiedFlowDataAnalysis.vue')

// 智能化客户详情页面
const SmartCustomerDetail = () => import('../components/customer-detail/SmartCustomerDetail.vue')

// 待入客户管理模块
const PendingCustomerManagement = () => import('../views/master-data/customer/pending/index.vue')

// 客户类型管理模块
const CustomerTypeManagement = () => import('../views/master-data/customer/type-management/index.vue')
const CustomerTypeDetail = () => import('../views/master-data/customer/type-management/components/CustomerTypeDetail.vue')
const CustomerTypeEdit = () => import('../views/master-data/customer/type-management/components/CustomerTypeEdit.vue')

// 销售代表管理组件
const OrganizationTree = () => import('../components/representative/OrganizationTree.vue')
const RepresentativeDashboard = () => import('../components/representative/RepresentativeDashboard.vue')
const AssignmentManagement = () => import('../components/representative/AssignmentManagement.vue')
const AssignmentHistory = () => import('../components/representative/AssignmentHistory.vue')
const AcademicPage = () => import('../views/master-data/representative/academic-page.vue')
const RepresentativeManager = () => import('../views/master-data/representative-manager.vue')

// 流向申述
const FlowAppeal = () => import('../views/flow-appeal/index.vue')
const AppealForm = () => import('../views/flow-appeal/appeal-form.vue')
const AppealFormOld = () => import('../views/flow-appeal/appeal-form-optimized.vue')
const AppealProcess = () => import('../views/flow-appeal/appeal-process.vue')
const MissingReport = () => import('../views/flow-appeal/missing-report.vue')
const AppealList = () => import('../views/flow-appeal/appeal-list.vue')
const AlertList = () => import('../views/flow-appeal/alert-list.vue')
const AlertDetail = () => import('../views/flow-appeal/alert-detail.vue')
const AlertRules = () => import('../views/flow-appeal/alert-rules.vue')
const CorrectionList = () => import('../views/flow-appeal/correction-list.vue')
const CorrectionDetail = () => import('../views/flow-appeal/correction-detail.vue')
const CorrectionCreate = () => import('../views/flow-appeal/correction-create.vue')

// 返利计算
const RebateCalculation = () => import('../views/rebate-calculation/index.vue')
// const RebatePolicy = () => import('../views/rebate-calculation/policy.vue') // 旧版返利政策页面，现已由policy-management.vue替代
const RebatePolicyManagement = () => import('../views/rebate-calculation/policy-management.vue') // 更完整的返利政策管理实现
const RebateCalculator = () => import('../views/rebate-calculation/calculation.vue')
const RebateReports = () => import('../views/rebate-calculation/reports/index.vue')
const RebateResult = () => import('../views/rebate-calculation/results/index.vue') // 更完整的返利结果实现
const RebateResultDetail = () => import('../views/rebate-calculation/results/detail.vue') // 返利结果详情页
const RebateAnalysis = () => import('../views/rebate-calculation/analysis.vue')

// 数据分析
const DataAnalysis = () => import('../views/data-analysis/index.vue')
const BalanceAnalysis = () => import('../views/data-analysis/balance-analysis.vue')
const BalanceDetail = () => import('../views/data-analysis/balance-detail.vue')
const ChannelAnalysis = () => import('../views/data-analysis/channel-analysis.vue')
const MultiDimensionAnalysis = () => import('../views/data-analysis/multi-dimension.vue')
const TerminalPenetrationView = () => import('../views/data-analysis/terminal-penetration.vue')
const MarketInsightView = () => import('../views/data-analysis/market-insight.vue')
const InventoryAlert = () => import('../views/data-analysis/inventory-alert.vue')
const SalesRanking = () => import('../views/data-analysis/sales-ranking.vue')

// 系统设置
const SystemSettings = () => import('../views/system-settings/index.vue')
const ApiTester = () => import('../views/system-settings/api-tester.vue')
const PerformanceMonitor = () => import('../views/system-settings/performance-monitor.vue')
const IntegrationTester = () => import('../views/system-settings/integration-tester.vue')
const ApiDocs = () => import('../views/system-settings/api-docs.vue')
// 使用role目录下更完整的角色管理组件，包含菜单权限功能
const RoleManagement = () => import('../views/system-settings/role/role-management.vue')
// 以下是permission目录下的角色管理组件，功能相似但UI不同，目前使用role目录下的实现
// const RoleManagementOld = () => import('../views/system-settings/permission/role-management.vue')
const UserManagement = () => import('../views/system-settings/user/user-management.vue')
const DictionaryManagement = () => import('../views/system-settings/dictionary/dictionary-management.vue')
// 新增基础设置组件
const BasicSettings = () => import('../views/system-settings/components/BasicSettings.vue')
// 新增系统日志组件
const SystemLogs = () => import('../views/system-settings/components/SystemLogs.vue')
// 菜单权限功能已集成在角色管理组件中
// const MenuPermission = () => import('../views/system-settings/permission/menu-permission.vue') // 未找到该文件，保持注释
// 数据权限功能已集成在角色管理组件中
// const DataPermission = () => import('../views/system-settings/permission/data-permission.vue') // 未找到该文件，保持注释
// API权限功能已集成在角色管理组件中
// const ApiManagement = () => import('../views/system-settings/permission/api-management.vue') // 未找到该文件，保持注释
// const SapIntegration = () => import('../views/system-settings/integration/sap-integration.vue') // 未找到该文件，保持注释
// const HrIntegration = () => import('../views/system-settings/integration/hr-integration.vue') // 未找到该文件，保持注释
const ThirdPartyIntegration = () => import('../views/system-settings/integration/third-party.vue')

// 添加历史记录详情页面路由
const ProcessHistoryDetail = () => import('../views/data-process/history/detail.vue')

// 导入个人设置页面组件
const UserProfile = () => import('../views/user/profile.vue')

// 导入通知中心组件
const NotificationCenter = () => import('../views/notification/center.vue')

// 新增：导入模板配置主页组件 (路径可根据实际情况调整)
const TemplateConfigIndex = () => import('../views/data-process/template-config/Index.vue');
// 新增：导入数据验证模板列表组件
const DataValidationList = () => import('../views/data-process/template-config/data-validation/DataValidationList.vue');
// 新增：导入数据验证模板编辑器组件
const DataValidationEditor = () => import('../views/data-process/template-config/data-validation/DataValidationEditor.vue');

// 新增：导入映射模板列表组件 (用于子路由)
const MappingList = () => import('../views/data-process/template-config/mapping/MappingList.vue');
// 新增：导入映射模板查看和编辑组件
const MappingView = () => import('../views/data-process/template-config/mapping/MappingView.vue');
const MappingEdit = () => import('../views/data-process/template-config/mapping/MappingEdit.vue');
const MappingVersions = () => import('../views/data-process/template-config/mapping/MappingVersions.vue');

// 导入测试页面
const TestApi = () => import('../views/test-api.vue')

// 规则配置相关组件
const RuleConfigList = () => import('@/views/data-process/rule-config/list.vue')
const RuleConfigCreate = () => import('@/views/data-process/rule-config/create.vue')
const RuleConfigEdit = () => import('@/views/data-process/rule-config/edit.vue')
const RuleConfigDetail = () => import('@/views/data-process/rule-config/detail.vue')

// 路由配置
const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: '登录', requiresAuth: false, skipIPCheck: false }
  },
  {
    path: '/access-denied',
    name: 'AccessDenied',
    component: AccessDenied,
    meta: { title: '访问被拒绝', requiresAuth: false, skipIPCheck: true }
  },
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: { title: '控制面板', requiresAuth: true }
  },
  // 添加API测试路由
  {
    path: '/test-api',
    name: 'TestApi',
    component: TestApi,
    meta: { title: 'API测试', requiresAuth: false }
  },
  // 添加智能化客户详情测试路由
  {
    path: '/test-smart-customer-detail',
    name: 'TestSmartCustomerDetail',
    component: () => import('../views/test-smart-customer-detail.vue'),
    meta: { title: '智能化客户详情测试', requiresAuth: false }
  },
  

  //添加流向数据路由
  flowDataRoutes,

  // 添加异常管理中心路由
  anomalyCenterRoutes,

  // 添加数据分析路由
  dataAnalysisRoutes,

  // 添加统一客户管理路由
  unifiedCustomerRoutes,

  // 添加销售代表主数据路由
  representativeRoutes,

  // 添加药品代理商系统路由
  agentRoutes,

  // 添加审计支撑中心路由（V1 新增）
  ...auditSupportRoutes,

  // 添加经营大脑门户路由（三核一舱）
  ...operationBrainRoutes,

  // 添加系统管理路由
  ...systemRoutes,

  // 数据处理
  {
    path: '/data-process',
    name: 'DataProcess',
    component: DataProcess,
    meta: { title: '数据处理', requiresAuth: true },
    children: [
      // 数据导入 - 保留原有入口页面作为导航
      {
        path: 'import',
        name: 'DataImport',
        component: DataImport,
        meta: { title: '数据导入', requiresAuth: true }
      },
      // 数据导入 - 独立的三级菜单页面(已升级为重构版)
      {
        path: 'import/file',
        name: 'FileImportPage',
        component: FileImportNew, // 已切换为新版重构组件
        meta: { title: '文件导入', requiresAuth: true }
      },
      // 数据导入（新）
      {
        path: 'import/file-new',
        name: 'FileImportPageNew',
        component: () => import('../views/data-process/import/FileImportNewCopy.vue'),
        meta: { title: '数据导入（新）', requiresAuth: true }
      },
      // 业务规则核验（新）- 合并了核验与核算
      {
        path: 'import/business-verify-new',
        name: 'BusinessVerifyNew',
        component: () => import('../views/data-process/import/BusinessVerifyNew.vue'),
        meta: { title: '业务规则核验', requiresAuth: true }
      },
      // 业务核验全局配置（新）- 合并了基础规则与核算配置
      {
        path: 'import/business-verify-config',
        name: 'BusinessVerifyConfig',
        component: () => import('../views/data-process/import/BusinessVerifyConfig.vue'),
        meta: { title: '业务核验配置', requiresAuth: true }
      },
      // 精简导入 - 极致优化版
      {
        path: 'import/simplified',
        name: 'SimplifiedImport',
        component: () => import('../views/data-process/import/SimplifiedImport.vue'),
        meta: { title: '精简导入', requiresAuth: true, icon: 'ThunderboltOutlined' }
      },
      // 旧版文件导入(已弃用,保留路径用于兼容旧链接)
      {
        path: 'import/file-old',
        name: 'FileImportOld',
        component: FileImportPage,
        meta: { title: '文件导入(旧版)', requiresAuth: true }
      },
      {
        path: 'import/web',
        name: 'WebImportPage',
        component: WebImportPage,
        meta: { title: '网站采集', requiresAuth: true }
      },
      {
        path: 'import/ddi',
        name: 'DdiImportPage',
        component: DdiImportPage,
        meta: { title: 'DDI对接', requiresAuth: true }
      },
      {
        path: 'import/manual',
        name: 'ManualImportPage',
        component: ManualImportPage,
        meta: { title: '手动录入', requiresAuth: true }
      },
      // 导入详情页面
      {
        path: 'import/detail/:id',
        name: 'ImportDetail',
        component: () => import('../views/data-process/import/import-detail.vue'),
        meta: { title: '导入详情', requiresAuth: true }
      },
      // 导入完成确认页面
      {
        path: 'import/completion/:id',
        name: 'ImportCompletion',
        component: () => import('../views/data-process/import/import-completion.vue'),
        meta: { title: '导入完成', requiresAuth: true }
      },
      // V2.0: 数据清洗确认测试页面 (开发调试用,已废弃)
      {
        path: 'import/cleaning-test',
        name: 'DataCleaningTest',
        component: DataCleaningTest,
        meta: { title: '数据清洗测试', requiresAuth: true }
      },
      // 数据确认页面 (正式生产页面)
      {
        path: 'import/data-cleaning',
        name: 'DataCleaningPage',
        component: DataCleaningPage,
        meta: { title: '数据确认', requiresAuth: true }
      },
      // 数据确认页面（新）- 适配新流程
      {
        path: 'import/data-cleaning-new',
        name: 'DataCleaningPageNew',
        component: () => import('../views/data-process/import/DataCleaningPageNew.vue'),
        meta: { title: '数据确认', requiresAuth: true }
      },
      // 数据核验结果页面 (Sprint 3 新增)
      {
        path: 'import/data-verification',
        name: 'DataVerificationPage',
        component: DataVerificationPage,
        meta: { title: '数据核验', requiresAuth: true }
      },
      // DDI管理
      {
        path: 'ddi-management',
        name: 'DdiManagement',
        component: DdiManagement,
        meta: { title: 'DDI连接管理', requiresAuth: true }
      },
      // 网站配置管理
      {
        path: 'website-config',
        name: 'WebsiteConfig',
        component: WebsiteConfig,
        meta: { title: '网站配置管理', requiresAuth: true }
      },
      // 字段映射模板管理
      {
        path: 'field-mapping-template',
        name: 'FieldMappingTemplate',
        component: () => import('../views/template-management/TemplateConfigPage.vue'),
        meta: { title: '映射模板管理', requiresAuth: true }
      },
      // 数据标准化 (将被移除)
      {
        path: 'standardization',
        name: 'Standardization',
        component: Standardization,
        meta: { title: '数据标准化', requiresAuth: true }
      },
      // 数据核验入口
      {
        path: 'verification',
        name: 'Verification',
        component: VerificationWorkbench,
        meta: { title: '数据核验', requiresAuth: true }
      },
      // 核验配置管理
      {
        path: 'verification/config',
        name: 'VerificationConfig',
        component: VerificationConfig,
        meta: { title: '核验配置管理', requiresAuth: true }
      },
      // 数据修复工具
      {
        path: 'verification/data-fix-tool',
        name: 'DataFixTool',
        component: DataFixTool,
        meta: { title: '数据修复工具', requiresAuth: true }
      },
      // 多级审批配置
      {
        path: 'verification/approval-flow-config',
        name: 'ApprovalFlowConfig',
        component: ApprovalFlowConfig,
        meta: { title: '审批流程配置', requiresAuth: true }
      },
      // 数据核算 (Stage 7 - 双层门控) - 已隐藏
      {
        path: 'accounting',
        name: 'Accounting',
        component: () => import('../views/data-process/import/DataAccountingPage.vue'),
        meta: { title: '数据核算', requiresAuth: true, hidden: true }
      },
      // 数据核算(旧版,保留用于参考) - 已隐藏
      {
        path: 'accounting-old',
        name: 'AccountingOld',
        component: Accounting,
        meta: { title: '数据核算(旧版)', requiresAuth: true, hidden: true }
      },
      // 数据核算配置管理 - 已隐藏
      {
        path: 'accounting/config',
        name: 'AccountingConfig',
        component: () => import('../views/data-process/accounting/AccountingConfigPage.vue'),
        meta: { title: '核算配置', requiresAuth: true, hidden: true }
      },
      // V4.1 自定义验证器管理
      {
        path: 'accounting/custom-validators',
        name: 'CustomValidators',
        component: () => import('../views/data-process/accounting/custom-validators.vue'),
        meta: { title: '自定义验证器', requiresAuth: true }
      },
      // 报表生成 - 注释保留，因为未找到实现
      /*
      {
        path: 'reporting',
        name: 'Reporting',
        component: Reporting,
        meta: { title: '报表生成', requiresAuth: true }
      },
      */
      // 新增：模板配置主页的子路由 - 已隐藏
      {
        path: 'template-config', // 这将匹配 /data-process/template-config
        name: 'TemplateConfigIndex',
        component: TemplateConfigIndex,
        redirect: '/data-process/template-config/data-validation', // 重定向到默认子路由
        meta: { title: '数据规则配置', requiresAuth: true, hidden: true },
        children: [
          {
            path: 'data-validation', // 列表页路由
            name: 'DataValidationList', 
            component: DataValidationList,
            meta: { title: '数据验证模板', requiresAuth: true, hidden: true }
          },
          {
            path: 'data-validation/create', // 新建页路由
            name: 'DataValidationCreate',
            component: DataValidationEditor,
            meta: { title: '新建验证模板', requiresAuth: true, hidden: true }
          },
          {
            path: 'data-validation/edit/:id', // 编辑页路由
            name: 'DataValidationEdit',
            component: DataValidationEditor,
            meta: { title: '编辑验证模板', requiresAuth: true, hidden: true }
          },
          {
            path: 'data-validation/view/:id', // 查看页路由
            name: 'DataValidationView',
            component: DataValidationEditor,
            meta: { title: '查看验证模板', requiresAuth: true, hidden: true }
          },
          {
            path: 'mapping', // 列表页路由
            name: 'MappingTemplateList', 
            component: MappingList,
            meta: { title: '数据映射模板', requiresAuth: true, hidden: true }
          },
          {
            path: 'mapping/view/:id', // 查看页路由
            name: 'MappingView',
            component: MappingView,
            meta: { title: '查看映射模板', requiresAuth: true, hidden: true }
          },
          {
            path: 'mapping/edit/:id', // 编辑页路由
            name: 'MappingEdit',
            component: MappingEdit,
            meta: { title: '编辑映射模板', requiresAuth: true, hidden: true }
          },
          {
            path: 'mapping/versions/:id', // 版本历史页路由
            name: 'MappingVersions',
            component: MappingVersions,
            meta: { title: '版本历史', requiresAuth: true, hidden: true }
          },
          {
            path: 'mapping/create', // 创建页路由
            name: 'MappingCreate',
            component: MappingEdit, // 重用编辑组件
            meta: { title: '创建映射模板', requiresAuth: true, hidden: true }
          },
        ]
      },
      // 处理历史
      {
        path: 'history',
        name: 'ProcessHistory',
        component: ProcessHistory,
        meta: { title: '处理历史', requiresAuth: true },
        children: [
          {
            path: 'detail/:id',
            name: 'ProcessHistoryDetail',
            component: ProcessHistoryDetail,
            props: true
          }
        ]
      }
    ]
  },
  // 规则管理中心
  {
    path: '/rule-management',
    name: 'RuleManagement',
    component: RuleManagement,
    meta: { title: '规则管理中心', requiresAuth: true }
  },
  {
    path: '/rule-management/list',
    name: 'RuleList',
    component: RuleList,
    meta: { title: '规则列表', requiresAuth: true }
  },
  {
    path: '/rule-management/create',
    name: 'RuleCreate',
    component: RuleEditor,
    meta: { title: '创建规则', requiresAuth: true }
  },
  {
    path: '/rule-management/view/:id',
    name: 'RuleView',
    component: () => import('../views/rule-management/view/index.vue'),
    meta: { title: '查看规则', requiresAuth: true, readonly: true }
  },
  {
    path: '/rule-management/edit/:id',
    name: 'RuleEdit',
    component: RuleEditor,
    meta: { title: '编辑规则', requiresAuth: true }
  },
  {
    path: '/rule-management/editor',
    name: 'RuleEditor',
    component: RuleEditor,
    meta: { title: '规则编辑', requiresAuth: true }
  },
  {
    path: '/rule-management/editor/:id',
    name: 'RuleEditorWithId',
    component: RuleEditor,
    meta: { title: '编辑规则', requiresAuth: true }
  },
  {
    path: '/rule-management/tester',
    name: 'RuleTester',
    component: RuleTester,
    meta: { title: '规则测试', requiresAuth: true }
  },
  {
    path: '/rule-management/test/:id',
    name: 'RuleTest',
    component: RuleTester,
    meta: { title: '测试规则', requiresAuth: true }
  },
  {
    path: '/rule-management/tester/:id',
    name: 'RuleTesterWithId',
    component: RuleTester,
    meta: { title: '测试规则', requiresAuth: true }
  },
  {
    path: '/rule-management/versions',
    name: 'RuleVersionsSelect',
    component: RuleVersions,
    meta: { title: '规则版本管理', requiresAuth: true }
  },
  {
    path: '/rule-management/versions/:id',
    name: 'RuleVersions',
    component: RuleVersions,
    meta: { title: '规则版本历史', requiresAuth: true }
  },
  // 模板管理中心 (将被移除)
  // {
  //   path: '/template-management',
  //   name: 'TemplateManagement',
  //   component: TemplateManagement,
  //   meta: { title: '模板管理中心', requiresAuth: true }
  // },
  // {
  //   path: '/template-management/editor',
  //   name: 'TemplateEditor',
  //   component: TemplateEditor,
  //   meta: { title: '模板编辑', requiresAuth: true }
  // },
  // {
  //   path: '/template-management/editor/:id',
  //   name: 'TemplateEditorWithId',
  //   component: TemplateEditor,
  //   meta: { title: '编辑模板', requiresAuth: true }
  // },
  // {
  //   path: '/template-management/versions/:id',
  //   name: 'TemplateVersions',
  //   component: TemplateVersions,
  //   meta: { title: '模板版本历史', requiresAuth: true }
  // },
  // 主数据管理
  {
    path: '/master-data',
    name: 'MasterData',
    component: MasterData,
    meta: { title: '主数据管理', requiresAuth: true },
    children: [
      {
        path: 'product',
        name: 'ProductMasterData',
        component: ProductMasterData,
        meta: { title: '产品主数据', requiresAuth: true }
      },
      {
        path: 'spec',
        name: 'SpecMasterData',
        component: SpecMasterData,
        meta: { title: '规格主数据', requiresAuth: true }
      },
      {
        path: 'spec/detail/:id',
        name: 'SpecDetail',
        component: SpecDetail,
        meta: { title: '规格详情', requiresAuth: true }
      },
      {
        path: 'spec/edit/:id',
        name: 'SpecEdit',
        component: SpecEdit,
        meta: { title: '编辑规格', requiresAuth: true }
      },
      {
        path: 'spec/edit',
        name: 'SpecCreate',
        component: SpecEdit,
        meta: { title: '新增规格', requiresAuth: true }
      },
      {
        path: 'product/detail/:id',
        name: 'ProductDetail',
        component: ProductDetail,
        meta: { title: '产品详情', requiresAuth: true }
      },
      {
        path: 'product/edit/:id',
        name: 'ProductEdit',
        component: ProductEdit,
        meta: { title: '编辑产品', requiresAuth: true }
      },
      {
        path: 'product/create',
        name: 'ProductCreate',
        component: ProductEdit,
        meta: { title: '新增产品', requiresAuth: true }
      },
      {
        path: 'organization',
        name: 'OrganizationMasterData',
        component: OrganizationMasterData,
        meta: { title: '组织架构', requiresAuth: true }
      },
      {
        path: 'organization/:id',
        name: 'OrganizationDetail',
        component: () => import('../views/master-data/organization/detail.vue'),
        meta: { title: '组织机构详情', requiresAuth: true }
      },
      {
        path: 'organization/position',
        name: 'PositionManagement',
        component: PositionManagement,
        meta: { title: '岗位管理', requiresAuth: true }
      },
      {
        path: 'organization/employee',
        name: 'EmployeeAssociation',
        component: EmployeeAssociation,
        meta: { title: '人员关联', requiresAuth: true }
      },
      {
        path: 'organization/region-coverage',
        name: 'OrganizationRegionCoverage',
        component: () => import('../views/master-data/organization/components/OrganizationRegionCoverage.vue'),
        meta: { title: '区域覆盖管理', requiresAuth: true }
      },
      {
        path: 'region',
        name: 'RegionMasterData',
        redirect: '/master-data/region/management',
        meta: { title: '区域数据管理', requiresAuth: true }
      },
      {
        path: 'region/management',
        name: 'RegionManagement',
        component: RegionManagement,
        meta: { title: '区域数据管理', requiresAuth: true }
      },
      {
        path: 'region/detail/:id',
        name: 'RegionDetail',
        component: RegionDetail,
        meta: { title: '区域详情', requiresAuth: true }
      },
      {
        path: 'region/edit/:id',
        name: 'RegionEdit',
        component: RegionEdit,
        meta: { title: '编辑区域', requiresAuth: true }
      },
      {
        path: 'region/add',
        name: 'RegionAdd',
        component: RegionAdd,
        meta: { title: '新增区域', requiresAuth: true }
      },
      {
        path: 'region/selector-demo',
        name: 'RegionSelectorDemo',
        component: RegionSelectorDemo,
        meta: { title: '地区选择器演示', requiresAuth: true }
      },
      {
        path: 'price',
        name: 'PriceMasterData',
        component: PriceMasterData,
        meta: { title: '价格主数据', requiresAuth: true }
      },
      {
        path: 'price/detail/:id',
        name: 'PriceDetail',
        component: PriceDetail,
        meta: { title: '价格详情', requiresAuth: true }
      },
      {
        path: 'price/edit/:id',
        name: 'PriceEdit',
        component: PriceEdit,
        meta: { title: '编辑价格', requiresAuth: true }
      },
      {
        path: 'price/create',
        name: 'PriceCreate',
        component: PriceEdit,
        meta: { title: '新增价格', requiresAuth: true }
      },
      // 新增价格管理相关路由
      {
        path: 'price/type-manager',
        name: 'PriceTypeManager',
        component: PriceTypeManager,
        meta: { title: '价格类型管理', requiresAuth: true }
      },
      {
        path: 'price/spec-relation',
        name: 'PriceSpecRelation',
        component: PriceSpecRelation,
        meta: { title: '规格价格关联', requiresAuth: true }
      },
      {
        path: 'price/validator',
        name: 'PriceValidator',
        component: PriceValidator,
      },
      
  
    
      // 客户管理
      {
        path: 'customer',
        name: 'CustomerManagement',
        component: CustomerManagement,
        meta: { title: '客户管理', requiresAuth: true }
      },
      {
        path: 'customer/add',
        name: 'CustomerAdd',
        component: CustomerAdd,
        meta: { title: '新增客户', requiresAuth: true }
      },
      {
        path: 'customer/detail/:id',
        name: 'CustomerDetail',
        component: UnifiedCustomerView,
        meta: { title: '客户详情', requiresAuth: true }
      },
      {
        path: 'customer/smart-detail/:id',
        name: 'SmartCustomerDetail',
        component: SmartCustomerDetail,
        meta: { title: '智能化客户详情', requiresAuth: true }
      },
      {
        path: 'customer/edit/:id',
        name: 'CustomerEdit',
        component: UnifiedCustomerView,
        props: route => ({ editMode: true, customerId: route.params.id }),
        meta: { title: '编辑客户', requiresAuth: true }
      },
      {
        path: 'customer/unified',
        name: 'UnifiedCustomerView',
        component: UnifiedCustomerView,
        meta: { title: '统一客户视图', requiresAuth: true }
      },
      {
        path: 'customer/pending',
        name: 'PendingCustomerManagement',
        component: PendingCustomerManagement,
        meta: { title: '待入客户管理', requiresAuth: true }
      },
      {
        path: 'customer/flow-analysis/:id',
        name: 'CustomerFlowAnalysis',
        component: UnifiedFlowDataAnalysis,
        meta: { title: '客户流向分析', requiresAuth: true }
      },
      // 将所有旧类型快速入口路由定向到统一客户管理
      {
        path: 'customer/distributor',
        redirect: 'customer/unified',
        meta: { title: '经销商管理', requiresAuth: true }
      },
      {
        path: 'customer/chain',
        redirect: 'customer/unified',
        meta: { title: '连锁管理', requiresAuth: true }
      },
      {
        path: 'customer/store',
        redirect: 'customer/unified',
        meta: { title: '门店管理', requiresAuth: true }
      },
      {
        path: 'customer/other',
        redirect: 'customer/unified',
        meta: { title: '其他客户管理', requiresAuth: true }
      },
      // 客户类型管理
      {
        path: 'customer/type-management',
        name: 'CustomerTypeManagement',
        component: CustomerTypeManagement,
        meta: { title: '客户类型管理', requiresAuth: true }
      },
      {
        path: 'customer/type-management/detail/:id',
        name: 'CustomerTypeDetail',
        component: CustomerTypeDetail,
        meta: { title: '客户类型详情', requiresAuth: true }
      },
      {
        path: 'customer/type-management/edit/:id',
        name: 'CustomerTypeEdit',
        component: CustomerTypeEdit,
        meta: { title: '编辑客户类型', requiresAuth: true }
      },
      {
        path: 'customer/type-management/tools',
        name: 'CustomerTypeTools',
        component: () => import('../views/master-data/customer/type-management/tools.vue'),
        meta: { title: '客户类型工具', requiresAuth: true, admin: true }
      },
      // 销售代表管理入口
      {
        path: 'representative',
        name: 'RepresentativeManager',
        component: RepresentativeManager,
        meta: { title: '销售代表管理', requiresAuth: true }
      },
      // 销售代表管理路由
      {
        path: 'representative/dashboard',
        name: 'RepresentativeDashboard',
        component: RepresentativeDashboard,
        meta: { title: '代表工作台', requiresAuth: true }
      },
      {
        path: 'representative/organization',
        name: 'OrganizationTree',
        component: OrganizationTree,
        meta: { title: '销售组织结构', requiresAuth: true }
      },
      {
        path: 'representative/assignment',
        name: 'AssignmentManagement',
        component: () => import('../views/master-data/representative/assignment-page.vue'),
        meta: { title: '分管关系管理', requiresAuth: true }
      },
      {
        path: 'representative/history',
        name: 'AssignmentHistory',
        component: AssignmentHistory,
        meta: { title: '分管历史记录', requiresAuth: true }
      },
      {
        path: 'representative/academic',
        name: 'AcademicActivityManagement',
        component: AcademicPage,
        meta: { title: '学术活动管理', requiresAuth: true }
      },
    ]
  },
  // 流向申诉系统路由
{
  path: '/flow-appeal',
  component: FlowAppeal,
  redirect: '/flow-appeal/list',
  meta: { title: '流向申诉', requiresAuth: true },
  children: [
    {
      path: 'list',
      name: 'AppealList',
      component: AppealList,
      meta: { title: '申诉列表', requiresAuth: true }
    }
  ]
},
// 申诉表单路由 - 支持创建、编辑和查看模式
{
  path: '/flow-appeal/form',
  name: 'AppealForm',
  component: AppealForm,
  alias: '/flow-appeal/appeal-form', // 兼容旧路径
  meta: { title: '流向数据申诉', requiresAuth: true }
},
  {
    path: '/flow-appeal/process/:id',
    name: 'AppealProcess',
    component: AppealProcess,
    meta: { title: '申述处理', requiresAuth: true }
  },
  {
    path: '/flow-appeal/appeal-track',
    name: 'AppealTrack',
    component: () => import('../views/flow-appeal/appeal-track.vue'),
    meta: { title: '申述跟踪', requiresAuth: true }
  },
  {
    path: '/flow-appeal/missing-report',
    name: 'MissingReport',
    redirect: '/flow-appeal/list',
    meta: { title: '漏采漏报处理 (已整合)', requiresAuth: true }
  },
  {
    path: '/flow-appeal/alert-list',
    name: 'AlertList',
    component: AlertList,
    meta: { title: '流向数据预警', requiresAuth: true }
  },
  {
    path: '/flow-appeal/alert-detail/:alertNo',
    name: 'AlertDetail',
    component: AlertDetail,
    meta: { title: '预警详情', requiresAuth: true }
  },
  {
    path: '/flow-appeal/alert-rules',
    name: 'AlertRules',
    component: AlertRules,
    meta: { title: '预警规则管理', requiresAuth: true }
  },
  {
    path: '/flow-appeal/correction-list',
    name: 'CorrectionList',
    component: CorrectionList,
    meta: { title: '数据修正', requiresAuth: true }
  },
  {
    path: '/flow-appeal/correction-detail/:correctionId',
    name: 'CorrectionDetail',
    component: CorrectionDetail,
    meta: { title: '修正详情', requiresAuth: true }
  },
  {
    path: '/flow-appeal/correction-create',
    name: 'CorrectionCreate',
    component: CorrectionCreate,
    meta: { title: '创建数据修正', requiresAuth: true }
  },

  // ========== 系统集成中心路由 ==========
  // 系统集成主页
  {
    path: '/system-settings/integration',
    name: 'SystemIntegration',
    component: () => import('../views/system-settings/integration/index.vue'),
    meta: { title: '系统集成', requiresAuth: true }
  },
  // 数据源管理
  {
    path: '/system-settings/integration/data-sources',
    name: 'IntegrationDataSources',
    component: () => import('../views/system-settings/integration/source-list.vue'),
    meta: { title: '数据源配置', requiresAuth: true }
  },
  {
    path: '/system-settings/integration/data-sources/:id',
    name: 'IntegrationDataSourceDetail',
    component: () => import('../views/system-settings/integration/source-detail.vue'),
    meta: { title: '数据源详情', requiresAuth: true }
  },
  // 数据目标管理
  {
    path: '/system-settings/integration/data-targets',
    name: 'IntegrationDataTargets',
    component: () => import('../views/system-settings/integration/target-list.vue'),
    meta: { title: '数据目标配置', requiresAuth: true }
  },
  {
    path: '/system-settings/integration/data-targets/:id',
    name: 'IntegrationDataTargetDetail',
    component: () => import('../views/system-settings/integration/target-detail.vue'),
    meta: { title: '数据目标详情', requiresAuth: true }
  },
  // 数据映射管理
  {
    path: '/system-settings/integration/mappings',
    name: 'IntegrationMappings',
    component: () => import('../views/system-settings/integration/mapping-list.vue'),
    meta: { title: '数据映射管理', requiresAuth: true }
  },
  {
    path: '/system-settings/integration/mappings/:id',
    name: 'IntegrationMappingDetail',
    component: () => import('../views/system-settings/integration/mapping-detail.vue'),
    meta: { title: '数据映射详情', requiresAuth: true }
  },
  // 同步任务监控
  {
    path: '/system-settings/integration/sync-tasks',
    name: 'IntegrationSyncTasks',
    component: () => import('../views/system-settings/integration/task-list.vue'),
    meta: { title: '同步任务监控', requiresAuth: true }
  },
  {
    path: '/system-settings/integration/sync-tasks/:id',
    name: 'IntegrationSyncTaskDetail',
    component: () => import('../views/system-settings/integration/task-detail.vue'),
    meta: { title: '同步任务详情', requiresAuth: true }
  },

  // 异常管理中心路由
  // 返利计算
  {
    path: '/rebate-calculation',
    name: 'RebateCalculation',
    component: RebateCalculation,
    meta: { title: '返利计算', requiresAuth: true }
  },
  // 返利政策路由 - 重定向到新版政策管理页面
  {
    path: '/rebate-calculation/policy',
    redirect: '/rebate-calculation/policy-management'
  },
  // 新版返利政策管理页面 
  {
    path: '/rebate-calculation/policy-management',
    name: 'RebatePolicyManagement',
    component: RebatePolicyManagement,
    meta: { title: '返利政策管理', requiresAuth: true }
  },
  // 添加政策详情路由
  {
    path: '/rebate-calculation/policy-detail/:id',
    name: 'RebatePolicyDetail',
    component: () => import('../views/rebate-calculation/policy-detail.vue'),
    meta: { title: '返利政策详情', requiresAuth: true }
  },
  // 添加政策编辑路由
  {
    path: '/rebate-calculation/policy-edit/:id?',
    name: 'RebatePolicyEdit',
    component: () => import('../views/rebate-calculation/policy-edit.vue'),
    meta: { title: '编辑返利政策', requiresAuth: true }
  },
  // 添加政策版本比较路由
  {
    path: '/rebate-calculation/policy-compare/:id',
    name: 'RebatePolicyCompare',
    component: () => import('../views/rebate-calculation/policy-compare.vue'),
    meta: { title: '返利政策版本比较', requiresAuth: true }
  },
  {
    path: '/rebate-calculation/calculator',
    name: 'RebateCalculator',
    component: RebateCalculator,
    meta: { title: '返利核算', requiresAuth: true }
  },
  // 新增：返利结算页面（迁移自返利计算-客户视图）
  {
    path: '/rebate-calculation/settlement',
    name: 'RebateSettlement',
    component: () => import('../views/rebate-calculation/settlement.vue'),
    meta: { title: '客户结算', requiresAuth: true }
  },
  {
    path: '/rebate-calculation/result',
    name: 'RebateResult',
    component: RebateResult,
    meta: { title: '返利结果', requiresAuth: true }
  },
  {
    path: '/rebate-calculation/result/detail/:id',
    name: 'RebateResultDetail',
    component: RebateResultDetail,
    meta: { title: '返利结果详情', requiresAuth: true }
  },
  {
    path: '/rebate-calculation/analysis',
    name: 'RebateAnalysis',
    component: RebateAnalysis,
    meta: { title: '返利分析', requiresAuth: true }
  },
  // 返利报表路由启用
  {
    path: '/rebate-calculation/reports',
    name: 'RebateReports',
    component: RebateReports,
    meta: { title: '返利报表', requiresAuth: true }
  },
  // 返利台账列表
  {
    path: '/rebate-calculation/ledger',
    name: 'RebateLedger',
    component: () => import('../views/rebate-calculation/ledger/index.vue'),
    meta: { title: '返利台账', requiresAuth: true }
  },
  // 返利台账-客户详情
  {
    path: '/rebate-calculation/ledger/:customerId',
    name: 'RebateLedgerDetail',
    component: () => import('../views/rebate-calculation/ledger/detail.vue'),
    meta: { title: '客户返利台账', requiresAuth: true }
  },
  // 数据分析
  {
    path: '/data-analysis',
    name: 'DataAnalysis',
    component: DataAnalysis,
    meta: { title: '数据分析', requiresAuth: true }
  },
  {
    path: '/data-analysis/balance-analysis',
    name: 'BalanceAnalysis',
    component: BalanceAnalysis,
    meta: { title: '进销存平衡分析', requiresAuth: true }
  },
  {
    path: '/data-analysis/balance-detail',
    name: 'BalanceDetail',
    component: BalanceDetail,
    meta: { title: '异常数据详情', requiresAuth: true }
  },
  {
    path: '/data-analysis/channel-analysis',
    name: 'ChannelAnalysis',
    component: ChannelAnalysis,
    meta: { title: '渠道销量占比分析', requiresAuth: true }
  },
  {
    path: '/data-analysis/multi-dimension',
    name: 'MultiDimensionAnalysis',
    component: MultiDimensionAnalysis,
    meta: { title: '多维度销量分析', requiresAuth: true }
  },
  {
    path: '/data-analysis/terminal-penetration',
    name: 'TerminalPenetrationAnalysis',
    component: TerminalPenetrationView,
    meta: { title: '终端穿透分析', requiresAuth: true }
  },
  {
    path: '/data-analysis/market-insight',
    name: 'MarketInsightAnalysis',
    component: MarketInsightView,
    meta: { title: '市场洞察与预测', requiresAuth: true }
  },
  {
    path: '/data-analysis/inventory-alert',
    name: 'InventoryAlert',
    component: InventoryAlert,
    meta: { title: '库存预警分析', requiresAuth: true }
  },
  {
    path: '/data-analysis/sales-ranking',
    name: 'SalesRanking',
    component: SalesRanking,
    meta: { title: '销量排行分析', requiresAuth: true }
  },
  // 系统设置
  {
    path: '/system-settings',
    name: 'SystemSettings',
    component: SystemSettings,
    meta: { title: '系统设置', requiresAuth: true }
  },
  {
    path: '/system-settings/api-tester',
    name: 'ApiTester',
    component: ApiTester,
    meta: { title: 'API接口测试', requiresAuth: true }
  },
  {
    path: '/system-settings/performance-monitor',
    name: 'PerformanceMonitor',
    component: PerformanceMonitor,
    meta: { title: '性能监控', requiresAuth: true }
  },
  {
    path: '/system-settings/integration-tester',
    name: 'IntegrationTester',
    component: IntegrationTester,
    meta: { title: '集成测试工具', requiresAuth: true }
  },
  {
    path: '/system-settings/api-docs',
    name: 'ApiDocs',
    component: ApiDocs,
    meta: { title: 'API接口文档', requiresAuth: true }
  },
  // 旧的角色管理和用户管理路由已移至 systemRoutes 模块 (使用新路径 /system/*)
  // {
  //   path: '/system-settings/role-management',
  //   name: 'RoleManagement',
  //   component: RoleManagement,
  //   meta: { title: '角色管理', requiresAuth: true }
  // },
  // {
  //   path: '/system-settings/user-management',
  //   name: 'UserManagement',
  //   component: UserManagement,
  //   meta: { title: '用户管理', requiresAuth: true }
  // },
  {
    path: '/system-settings/dictionary-management',
    name: 'DictionaryManagement',
    component: DictionaryManagement,
    meta: { title: '数据字典管理', requiresAuth: true }
  },
  {
    path: '/system-settings/basic-settings',
    name: 'BasicSettings',
    component: BasicSettings,
    meta: { title: '基础设置', requiresAuth: true }
  },
  {
    path: '/system-settings/system-logs',
    name: 'SystemLogs',
    component: SystemLogs,
    meta: { title: '系统日志', requiresAuth: true }
  },
  {
    path: '/system-settings/third-party',
    name: 'ThirdPartyIntegration',
    component: ThirdPartyIntegration,
    meta: { title: '第三方系统集成', requiresAuth: true }
  },
  // 重定向旧路径
  {
    path: '/data-flow',
    redirect: '/data-process'
  },
  {
    path: '/data-accounting',
    redirect: '/data-process/accounting'
  },
  {
    path: '/data-verification',
    redirect: '/data-process/verification'
  },
  // 个人设置页面路由
  {
    path: '/user/profile',
    name: 'UserProfile',
    component: UserProfile,
    meta: { title: '个人设置', requiresAuth: true }
  },
  // 通知中心路由
  {
    path: '/notification/center',
    name: 'NotificationCenter',
    component: NotificationCenter,
    meta: { title: '通知中心', requiresAuth: true }
  },
  // 规则配置相关路由
  {
    path: '/data-process/rule-config/list',
    name: 'RuleConfigList',
    component: RuleConfigList,
    meta: { title: '规则配置管理', requiresAuth: true }
  },
  {
    path: '/data-process/rule-config/create',
    name: 'RuleConfigCreate',
    component: RuleConfigCreate,
    meta: { title: '创建规则', requiresAuth: true }
  },
  {
    path: '/data-process/rule-config/edit/:id',
    name: 'RuleConfigEdit',
    component: RuleConfigEdit,
    meta: { title: '编辑规则', requiresAuth: true }
  },
  {
    path: '/data-process/rule-config/detail/:id',
    name: 'RuleConfigDetail',
    component: RuleConfigDetail,
    meta: { title: '规则详情', requiresAuth: true }
  },
  // 404页面
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 导入IP检查工具
import { getUserIP, checkIP, needsIPCheck } from '@/utils/ip-check'

// IP检查启用标志 (可以通过环境变量或配置文件控制)
const IP_CHECK_ENABLED = process.env.VUE_APP_ENABLE_IP_CHECK === 'true' || false

// 路由守卫
router.beforeEach(async (to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title ? `${to.meta.title} - 药品流向系统` : '药品流向系统'

  // 登录页面和访问拒绝页面不在路由守卫中检查IP
  // 登录页面会在组件内部检查IP
  const skipIPCheckRoutes = ['Login', 'AccessDenied']

  // IP白名单检查 (如果启用,且不是登录/访问拒绝页面)
  if (IP_CHECK_ENABLED && needsIPCheck(to) && !skipIPCheckRoutes.includes(to.name)) {
    try {
      const userIP = await getUserIP()

      if (!userIP) {
        console.error('无法获取用户IP地址')
        // 无法获取IP时,可以选择允许或拒绝访问
        // 这里选择拒绝访问以提高安全性
        next({ name: 'AccessDenied' })
        return
      }

      const isAllowed = await checkIP(userIP)

      if (!isAllowed) {
        console.warn(`IP ${userIP} 不在白名单中,拒绝访问`)
        next({ name: 'AccessDenied' })
        return
      }

      console.log(`IP ${userIP} 已通过白名单验证`)
    } catch (error) {
      console.error('IP检查过程出错:', error)
      // IP检查出错时的处理策略
      if (process.env.NODE_ENV === 'production') {
        // 生产环境:出错时拒绝访问
        next({ name: 'AccessDenied' })
        return
      }
      // 开发环境:出错时允许访问
      console.warn('开发环境:IP检查出错,允许访问')
    }
  }

  // 登录验证 (实际项目中应该检查token或其他认证信息)
  const isAuthenticated = localStorage.getItem('token')

  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: 'Login' })
  } else {
    next()
  }
})

export default router 